import { render, staticRenderFns } from "./CommentModal.vue?vue&type=template&id=61f36c10"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"
import style0 from "./CommentModal.vue?vue&type=style&index=0&id=61f36c10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports